import get from 'lodash/get';
import { useFormContext } from 'react-hook-form';
import { Chip } from 'shared/mui/Chips';
import { useAnchor } from 'shared/mui/DatePicker/hooks/useAnchor';
import { useFilterContext } from 'shared/mui/Filter/context/filterContext';
import { PopoverChip } from 'shared/mui/Filter/FilterChipsToolbar/FilterChips/components/PopoverChip/PopoverChip';

export type FilterTextChipProps = {
  label: string;
  name: string;
  children: React.ReactNode;
  clearable?: boolean;
  getName?: (filterValue: any) => string;
  onDelete?: () => void;
  onApply?: () => void;
  // по умолчанию не игнорировать false значения
  isNotIgnoreFalseValue?: boolean;
};

export const FilterTextChip: React.FC<FilterTextChipProps> = ({
  name,
  label,
  children,
  getName,
  onApply,
  onDelete,
  isNotIgnoreFalseValue = false,
  clearable = true,
}) => {
  const { setAppliedFilter, appliedFilters } = useFilterContext();
  const { handleClose, handleClick, anchorEl } = useAnchor<HTMLDivElement>();
  const { resetField, getValues, setValue } = useFormContext();
  const filterValue = get(appliedFilters, name);

  if (!filterValue && (typeof filterValue !== 'boolean' || !isNotIgnoreFalseValue)) {
    return <></>;
  }

  function onApplyHandler() {
    handleClose();
    onApply && onApply();
    setAppliedFilter(name, getValues(name));
  }

  function onResetHandler() {
    setAppliedFilter(name, filterValue);
    setValue(name, filterValue);
  }

  return (
    <>
      <PopoverChip
        anchorEl={anchorEl}
        onApply={onApplyHandler}
        onClose={handleClose}
        onReset={onResetHandler}
        open={!!anchorEl}
      >
        {children}
      </PopoverChip>
      <Chip
        label={`${label}: ${getName?.(filterValue) || filterValue}`}
        onClick={handleClick}
        onDelete={
          clearable
            ? () => {
                onDelete && onDelete();
                resetField(name);
                setAppliedFilter(name, null);
              }
            : undefined
        }
        size="medium"
      />
    </>
  );
};
